<template>
  <div class="sidebar-profile">
    <div class="sidebar-profile-grid" title="Contraer menú" @click="toggle_sidebar">
      <vue-feather type="grid" size="18"></vue-feather>
    </div>
    <div class="sidebar-profile-avatar">
      <span>{{ initials }}</span>
    </div>
    <div class="sidebar-profile-name">{{ userName }}</div>
    <div class="sidebar-profile-email">{{ userEmail }}</div>
    <div class="sidebar-profile-role">{{ userRole }}</div>
  </div>
</template>

<script>
export default {
  name: "SidebarProfileView",
  computed: {
    usuarioActual() {
      return this.$store.state.autenticacion?.usuarioActual ?? null;
    },
    roles() {
      return this.$store.state.autenticacion?.roles ?? [];
    },
    userEmail() {
      if (this.usuarioActual?.email) return this.usuarioActual.email;
      try {
        const stored = localStorage.getItem("user");
        if (!stored) return "";
        const parsed = JSON.parse(stored);
        return parsed.email || "";
      } catch (e) {
        return "";
      }
    },
    userName() {
      if (this.usuarioActual?.name) return this.usuarioActual.name;
      const email = this.userEmail;
      if (!email) return "Usuario";
      const namePart = email.split("@")[0] || "";
      if (!namePart) return "Usuario";
      const parts = namePart.split(/[.\-_]+/).filter(Boolean);
      if (!parts.length) return namePart;
      return parts
        .map((p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
        .join(" ");
    },
    initials() {
      const name = this.usuarioActual?.name || this.userName;
      if (name) {
        const parts = name.trim().split(/\s+/).filter(Boolean);
        if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
        if (parts[0].length >= 2) return parts[0].slice(0, 2).toUpperCase();
        return parts[0][0].toUpperCase();
      }
      const email = this.userEmail;
      if (!email) return "US";
      const namePart = email.split("@")[0] || "";
      const parts = namePart.split(/[.\-_ ]+/).filter(Boolean);
      if (!parts.length) return namePart.slice(0, 2).toUpperCase();
      const first = parts[0][0] || "";
      const second = parts[1] ? parts[1][0] : "";
      return (first + second).toUpperCase();
    },
    userRole() {
      const rolId = this.usuarioActual?.rol;
      if (rolId == null || rolId === "") return "Usuario";
      const roles = this.roles;
      const roleObj = roles.find((r) => String(r.id) === String(rolId));
      return roleObj?.name ?? (typeof rolId === "string" ? rolId : `Rol ${rolId}`);
    },
  },
  methods: {
    toggle_sidebar() {
      this.$store.dispatch("menu/opensidebar");
      this.$store.state.menu.activeoverlay = false;
    },
  },
};
</script>

<style scoped>
.sidebar-profile {
  padding: 24px 20px;
  text-align: center;
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}

.sidebar-profile-grid {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  transition: background-color 0.2s ease;
}

.sidebar-profile-grid:hover {
  background-color: rgba(255, 255, 255, 0.15);
}

.sidebar-profile-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: #fff;
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}

.sidebar-profile-name {
  font-size: 15px;
  font-weight: 600;
  color: #7c8aff;
  margin-bottom: 4px;
}

.sidebar-profile-email {
  font-size: 12px;
  color: #f59e0b;
  margin-bottom: 4px;
}

.sidebar-profile-role {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
}
</style>
